import HOME from "./home";

export default HOME;
